import Camera from '@/common/components/camera/components/Camera/Camera';
import CameraDenyPermissionModal from '@/common/components/camera/components/modals/cameraDenyPermision/CameraDenyPermissionModal';
import { photographyTitlesQueryOptions } from '@/common/components/camera/queries/photographingTitles/photographyTitlesQueryOptions';
import { ImageFlowCapturingDataType } from '@/common/components/camera/types/Camera.type';
import useModal from '@/common/hooks/useModal';
import getVehicleTypeQueryOption from '@/common/queries/getVehicleType/getVehicleTypeQueryOPtion';
import useDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/store/damagePoints/useDamagedPoints';
import { useImageFlowStore } from '@/modules/adjusterReportModules/IncidentParticipants/store/imageFlow/useImageFlowStore';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

const ImageFlow = ({
  finishFlow,
  navigateBack,
  filetype,
}: {
  finishFlow: () => void;
  navigateBack: () => void;
  filetype: 'initial' | 'property' | 'body';
}) => {
  const { damagedPoints } = useDamagedPoints();
  const { damagedId, id } = useParams();
  const { addImages, setVideo, resetCameraStore } = useImageFlowStore();
  const { closeModal, open, openModal } = useModal();

  const [captureData, setCaptureData] = useState<ImageFlowCapturingDataType>({
    damaged_parts: [],
    vehicle: [],
  });
  const { data: fileVehicleType, isSuccess } = useQuery(
    getVehicleTypeQueryOption({ damaged_pk: damagedId, file_pk: id! }),
  );
  useQuery(
    photographyTitlesQueryOptions({
      params: { vehicle_type: fileVehicleType?.id!, file_type: filetype },
      enabled: isSuccess,
      onSuccess: (data) => {
        setCaptureData({
          damaged_parts: damagedPoints.length
            ? damagedPoints.map((item) => ({
                id: Number(item.id),
                fa_name: `${item.name} - ${item.side}`,
                en_name: `${item.name} - ${item.side}`,
              }))
            : [],
          vehicle: data.map((item) => ({
            id: item.id,
            description: item.description,
            image: item.image,
            fa_name: item.fa_name,
            en_name: item.name,
            voice: item.voice ?? '',
          })),
        });
      },
    }),
  );

  return (
    <>
      <Camera
        vehicleType={fileVehicleType?.name!}
        captureData={captureData}
        onDenyCamera={openModal}
        handleClose={() => {
          resetCameraStore();
          navigateBack();
        }}
        handleCapturedImage={(data) => {
          addImages({
            id: data.id,
            blob: data.blob,
            url: data.url,
            type: data.type,
            label: data?.fa_name,
            en_name: data.en_name,
          });
        }}
        handleRecordedVideo={(data) => {
          setVideo(data);
        }}
        finishFlow={finishFlow}
        onRotate={() => {
          resetCameraStore();
          navigateBack();
        }}
      />
      {open && (
        <CameraDenyPermissionModal
          onClose={() => {
            resetCameraStore();
            navigateBack();
            closeModal();
          }}
          open={open}
        />
      )}
    </>
  );
};
export default ImageFlow;
